import type { ExpenseCreateFlow } from "@apps/dashboard/features/expenses/expense-create-flow";

const STORAGE_KEY = "he_expense_last_create_flow";

const PERSISTABLE: ReadonlySet<ExpenseCreateFlow> = new Set(["quick", "monthly", "series"]);

export function readLastExpenseCreateFlow(): ExpenseCreateFlow | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "quick" || raw === "monthly" || raw === "series") return raw;
  } catch {
    /* ignore */
  }
  return null;
}

export function writeLastExpenseCreateFlow(flow: ExpenseCreateFlow): void {
  if (!PERSISTABLE.has(flow)) return;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, flow);
  } catch {
    /* ignore */
  }
}
